import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesQueries } from 'data/graphql'
import { dataFetched } from 'data/graphql/reducer'

import { noteBaseAttributesFragment } from 'remote/notes'
import { channelAttrsFragment } from 'remote/channels'
import { userPreferencesAttrsFragment } from 'remote/users'

const RecentHistoryEntriesQuery = gql`
  query RecentHistory {
    showLastVisitedNotes {
      ...noteBaseAttributes
      channel {
        ...channelAttrs
      }
    }
    showLastVisitedChannels {
      id
      __typename
      name
      type
    }
    showUserPreferences {
      ...userPreferencesAttrs
      lastSearchedTerms
    }
  }
  ${noteBaseAttributesFragment}
  ${channelAttrsFragment}
  ${userPreferencesAttrsFragment}
`

export const providesRecentHistoryEntries = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesQueries({
    query: RecentHistoryEntriesQuery,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(
        []
          .concat(result.data.showLastVisitedChannels)
          .concat(result.data.showLastVisitedNotes)
          .concat(result.data.showUserPreferences)
      )
    },
  })
)
